import { render, staticRenderFns } from "./ContactInvoicesComponent.vue?vue&type=template&id=63fd53dc"
import script from "./ContactInvoicesComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactInvoicesComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fd53dc')) {
      api.createRecord('63fd53dc', component.options)
    } else {
      api.reload('63fd53dc', component.options)
    }
    module.hot.accept("./ContactInvoicesComponent.vue?vue&type=template&id=63fd53dc", function () {
      api.rerender('63fd53dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInvoices/ContactInvoicesComponent.vue"
export default component.exports